import React from "react";
import get from "lodash/get";
import { object, bool, string } from "prop-types";
import { Link } from "@quintype/components";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { HeroImage } from "../../atoms/HeroImage";
import { Label } from "../../atoms/Label";
import Headline from "../../atoms/Headline";
import SubHeadline from "../../atoms/SubHeadline";

import "./two-col-five-stories.m.css";

export const MainStory = ({
  story,
  showBorder,
  showSubheadline,
  showHeroImage = true,
  showReadTime,
  showTimestamp,
  sectionSlug,
}) => {
  const headline = getStoryHeadline(story);
  const imageUrl =
    get(story, ["hero-image-s3-key"], "") ||
    get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], "");

  const externalStoryUrl = isExternalStory(story);
  const label = getStoryLabel(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <Link href={href} target={target}>
      <div
        styleName={`main-story ${showHeroImage ? "" : "hide-hero-image"}`}
        style={{ borderBottom: showBorder || "none" }}
      >
        <div styleName="main-story-hero-image">
          {showHeroImage && (
            <HeroImage
              story={story}
              headline={headline}
              aspectRatio={[[4, 3]]}
              iconSizes={{ width: 64, height: 64 }}
              imageUrl={imageUrl}
            />
          )}
        </div>
        <div styleName="image-details">
          {label && <Label story={story} />}

          {headline && <Headline styleName="main-story-headline" headline={headline} sectionSlug={sectionSlug} />}
          {showSubheadline && story?.subheadline && (
            <SubHeadline styleName="subheadline" subHeadline={story?.subheadline} sectionSlug={sectionSlug} />
          )}
          <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimestamp} />
        </div>
      </div>
    </Link>
  );
};

MainStory.propTypes = {
  story: object,
  showHeroImage: bool,
  showBorder: bool,
  showReadTime: bool,
  showTimestamp: bool,
  showSubheadline: bool,
  sectionSlug: string,
};
